<template>
  <div class="section" id="app">
    <div class="container">
      <QuestionnaireWrapper/>
    </div>
  </div>
</template>

<script>
import './assets/css/main.scss';
export default {
  name: 'App',
}
</script>
